import React from "react";
import CustomDialog, { DialogData } from "./CustomDialog";

interface CurrencySelectionProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  all?: boolean;
  onClick: (icon: string | null, code: string) => void;
  data: DialogData[];
  onSearch: (search: string) => void;
  subtitle?: string;
}

export const CurrencySelection = (props: CurrencySelectionProps) => {
  const { open, setOpen, subtitle, all, data, onClick, onSearch } = props;

  return (
    <CustomDialog
      open={open}
      onSearch={onSearch}
      setOpen={setOpen}
      subtitle={subtitle}
      all={all}
      onClick={onClick}
      data={data}
    />
  );
};
